import { render, staticRenderFns } from "./stage23.vue?vue&type=template&id=1bd3729d&scoped=true&"
import script from "./stage23.vue?vue&type=script&lang=js&"
export * from "./stage23.vue?vue&type=script&lang=js&"
import style0 from "./stage23.vue?vue&type=style&index=0&id=1bd3729d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3729d",
  null
  
)

export default component.exports